<template>
  <a-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: disabled} }"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <div class="title">当前分配信息</div>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="招标项目编号">
              <a-input v-decorator="['tenderProjectCode', {}]" :readOnly="true"/>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="招标项目名称">
              <a-input placeholder="请输入招标项目名称" v-decorator="['tenderProjectName', {}]" :readOnly="true"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="标室类型">
              <j-dict-select-tag
                :disabled="true"
                dictCode="room_type"
                v-decorator="['openRoomType', validatorRules.openRoomType]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="标室名称">
              <a-select
                v-decorator="[ 'openRoomId', validatorRules.openRoomId]"
                placeholder="请选择标室名称"
                :getPopupContainer = "(target) => target.parentNode">
                <a-select-option v-for="item in openRoomSelectList" :value="item.id" :key="item.id">{{item.roomName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="开始时间:">
              <j-date style="width: 100%" :getCalendarContainer="node => node.parentNode" v-decorator="[ 'openBeginTime', validatorRules.openBeginTime]" placeholder="请选择开始时间" showTime dateFormat="YYYY-MM-DD HH:mm:ss"></j-date>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="结束时间"
              class="endTime">
              <j-date style="width: 100%" :getCalendarContainer="node => node.parentNode" v-decorator="[ 'openEndTime', validatorRules.openEndTime]" placeholder="请选择结束时间" showTime dateFormat="YYYY-MM-DD HH:mm:ss"></j-date>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="标室类型">
              <j-dict-select-tag
                :disabled="true"
                dictCode="room_type"
                v-decorator="['evalRoomType', validatorRules.evalRoomType]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="标室名称">
              <a-select
                v-decorator="[ 'evalRoomId', validatorRules.evalRoomId]"
                placeholder="请选择标室名称"
                :getPopupContainer = "(target) => target.parentNode">
                <a-select-option v-for="item in evalRoomSelectList" :value="item.id" :key="item.id">{{item.roomName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="width: 100%;">
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="开始时间:">
              <j-date style="width: 100%" :getCalendarContainer="node => node.parentNode" v-decorator="[ 'evalBeginTime', validatorRules.evalBeginTime]" placeholder="请选择开始时间" showTime dateFormat="YYYY-MM-DD HH:mm:ss"></j-date>
            </a-form-item>
          </a-col>
          <a-col :span="24/2">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="结束时间"
              class="endTime">
              <j-date style="width: 100%" :getCalendarContainer="node => node.parentNode" v-decorator="[ 'evalEndTime', validatorRules.evalEndTime]" placeholder="请选择结束时间" showTime dateFormat="YYYY-MM-DD HH:mm:ss"></j-date>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import { httpAction,postAction,getAction } from '@/api/manage'
  import JDate from '@/components/fzis/JDate'
  import JEditor from '@/components/fzis/JEditor'
  import moment from 'moment'
  import {getRoomList} from '@/api/room'

  export default {
    components: { JEditor, JDate},
    name: "RoomReApplyModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        labelColX1: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperColX1: {
          xs: { span: 24 },
          sm: { span: 21 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          openRoomId:{rules: [{ required: true, message: '请选择标室名称!' },{validator: this.openRoomValidate}]},
          openRoomType:{rules: [{ required: true, message: '请选择标室类型!' }]},
          openBeginTime:{rules:[{ required: true, message: '请选择结束时间!'} ,{validator: this.openBeginTimeValidate}]},
          openEndTime:{rules:[{required: true, message: '请选择结束时间!'},{validator: this.openEndTimeValidate}]},
          evalRoomId:{rules: [{ required: true, message: '请选择标室名称!' },{validator: this.evalRoomValidate}]},
          evalRoomType:{rules: [{ required: true, message: '请选择标室类型!' }]},
          evalBeginTime:{rules:[{ required: true, message: '请选择结束时间!'} ,{validator: this.evalBeginTimeValidate}]},
          evalEndTime:{rules:[{required: true, message: '请选择结束时间!'},{validator: this.evalEndTimeValidate}]},
        },
        url: {
          queryById: "/room/schedule/queryById",
        },
        disabled:false,
        openRoomSelectList:[],
        evalRoomSelectList:[],
        bidProjectId:"",
        openRoomTypes:["1","4","11"],
        evalRoomTypes:["2","3","5","12"],
        openRoomInfo:{},
        evalRoomInfo:{},
      }
    },
    created () {

    },
    methods: {
      show(openRoomInfo,evalRoomInfo) {
        this.openRoomInfo = openRoomInfo
        this.evalRoomInfo = evalRoomInfo
        let tempOpenInfo = {},tempEvalInfo = {}
        if (this.openRoomTypes.includes(openRoomInfo.roomType)){
          tempOpenInfo.openRoomId = openRoomInfo.roomId
          tempOpenInfo.openRoomType = openRoomInfo.roomType
          tempOpenInfo.openBeginTime = openRoomInfo.beginTime
          tempOpenInfo.openEndTime = openRoomInfo.endTime
        }
        if (this.evalRoomTypes.includes(evalRoomInfo.roomType)){
          tempEvalInfo.evalRoomId = evalRoomInfo.roomId
          tempEvalInfo.evalRoomType = evalRoomInfo.roomType
          tempEvalInfo.evalBeginTime = evalRoomInfo.beginTime
          tempEvalInfo.evalEndTime = evalRoomInfo.endTime
        }
        this.model = Object.assign({},tempOpenInfo,tempEvalInfo)
        if(openRoomInfo.id){
          this.getRoomList({"roomType":openRoomInfo.roomType})
          this.getRoomList({"roomType":evalRoomInfo.roomType})
        }
        this.form.resetFields();
        this.disable = false;
        this.visible = true;
        this.getRoomScheduleInfo(openRoomInfo.bidProjectId);

      },
      getRoomScheduleInfo(bidProjectId){
        getAction("/ebid-ce/tmBidProject/queryById",{id:bidProjectId}).then(res=>{
          if(res.success){
            this.model.tenderProjectCode = res.result.tenderProjectCode;
            this.model.tenderProjectName = res.result.tenderProjectName;
            this.$nextTick(() => {
                  setTimeout(() => {
                    this.form.setFieldsValue(pick(this.model,'openRoomId','openRoomType','openBeginTime','openEndTime','evalRoomId','evalRoomType','evalBeginTime','evalEndTime','tenderProjectCode','tenderProjectName'))
                  })
                })
          }
        })
      },
      getRoomList(param){
        if (this.openRoomTypes.includes(param.roomType)){
          getRoomList(param).then((res) => {
            this.openRoomSelectList=res.result;
          });
        }
        if (this.evalRoomTypes.includes(param.roomType)){
          getRoomList(param).then((res) => {
            this.evalRoomSelectList=res.result;
            //显示隔夜评标室
            if (param.roomType == "2"){
              getRoomList({roomType:"3"}).then((res1) => {
                this.evalRoomSelectList.push(...res1.result)
              })
            }
          });
        }
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.submit(err, values);
          }else {
            let keyList = [];
            for (let key in err) {
              if(key != 'openRoomId' && key != 'evalRoomId'){
                return;
              }else{
                keyList.push(key);
              }
            }
            if(keyList.length < 3){
              if(keyList[0] == 'openRoomId'){
                if(err.openRoomId.errors.length == 1 && err.openRoomId.errors[0].field=='openRoomId' && err.openRoomId.errors[0].message=='该标室该时间段已被占用'){
                  that.$confirm({
                    title:"信息确认",
                    content:"该标室该时间段已被占用，是否继续分配？",
                    onOk(){
                      that.submit(err, values);
                    }
                  });
                }
              }else if (keyList[0] == 'evalRoomId' || keyList[1] == 'evalRoomId'){
                if(err.evalRoomId.errors[0].field=='evalRoomId' && err.evalRoomId.errors[0].message=='该标室该时间段已被占用'){
                  that.$confirm({
                    title:"信息确认",
                    content:"该标室该时间段已被占用，是否继续分配？",
                    onOk(){
                      that.submit(err, values);
                    }
                  });
                }
              }
            }
          }
        });
      },
      submit(err, values){
        let that = this;
        that.confirmLoading = true;
        let params = {}
        params.openRoomInfo = {
          id:this.openRoomInfo.id,
          roomId:values.openRoomId,
          roomType:values.openRoomType,
          beginTime:values.openBeginTime,
          endTime:values.openEndTime
        }
        params.evalRoomInfo = {
          id:this.evalRoomInfo.id,
          roomId:values.evalRoomId,
          roomType:values.evalRoomType,
          beginTime:values.evalBeginTime,
          endTime:values.evalEndTime
        }
        this.form.setFieldsValue(pick(values,'openRoomId','openRoomType','openBeginTime','openEndTime','evalRoomId','evalRoomType','evalBeginTime','evalEndTime','tenderProjectCode','tenderProjectName'))
        postAction('/room/schedule/reAssignOpenAndEval',params).then((res)=>{
          if (res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }
        }).finally(() => {
          that.confirmLoading = false;
          that.close();
        })
      },
      handleCancel () {
        this.visible = false;
        this.$emit('close');
      },
      applyTimeValidate(rule,value,callback){
        callback()
      },
      checkTimeValidate(rule,value,callback){
        callback()
      },
      openBeginTimeValidate(rule,value,callback){
        callback();
        this.form.validateFields(['openEndTime'], { force: true });
      },
      openEndTimeValidate(rule,value,callback){
        let startTime = this.form.getFieldValue("openBeginTime");
        let endTime = this.form.getFieldValue("openEndTime");
        if(!endTime || !startTime){
          callback("请选择标室起止时间");
        }else if(moment(startTime).isBefore(endTime)){
          callback();
          this.form.validateFields(['openRoomId'], { force: true });
        }else{
          callback("结束时间需大于开始时间")
        }
      },

      evalBeginTimeValidate(rule,value,callback){
        callback();
        this.form.validateFields(['evalEndTime'], { force: true });
      },
      evalEndTimeValidate(rule,value,callback){
        let startTime = this.form.getFieldValue("evalBeginTime");
        let endTime = this.form.getFieldValue("evalEndTime");
        if(!endTime || !startTime){
          callback("请选择标室起止时间");
        }else if(moment(startTime).isBefore(endTime)){
          callback();
          this.form.validateFields(['evalRoomId'], { force: true });
        }else{
          callback("结束时间需大于开始时间")
        }
      },
      openRoomValidate(rule,value,callback){
        let endTime = this.form.getFieldValue("openEndTime");
        let startTime = this.form.getFieldValue("openBeginTime");
        if(startTime && endTime){
          postAction("/room/schedule/isRoomOccupied",{bidProjectId:this.bidProjectId,roomId:value,beginTime:startTime,endTime:endTime}).then((res)=>{
            if(res.success){
              if(res.result){
                callback("该标室该时间段已被占用");
              }else{
                callback();
              }
            }else{
              callback(res.message);
            }
          });
        }else{
          callback();
        }
      },
      evalRoomValidate(rule,value,callback){
        let endTime = this.form.getFieldValue("evalEndTime");
        let startTime = this.form.getFieldValue("evalBeginTime");
        if(startTime && endTime){
          postAction("/room/schedule/isRoomOccupied",{bidProjectId:this.bidProjectId,roomId:value,beginTime:startTime,endTime:endTime}).then((res)=>{
            if(res.success){
              if(res.result){
                callback("该标室该时间段已被占用");
              }else{
                callback();
              }
            }else{
              callback(res.message);
            }
          });
        }else{
          callback();
        }
      }
    }
  }
</script>

<style scoped>

</style>